import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { BToast } from 'bootstrap-vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import util from '@/util'
import { obterIcone } from '@/util/imagem'

export default {
  name: 'monitoramento-consumo',
  components: {
    spinnerProcessando,
    'b-toast': BToast,
    'default-table': defaultTable
  },
  props: {
    listaConsumos: {
      type: Array,
      default: []
    },
    fields: {
      type: Array,
      required: true
    },
    flagsDeControle: {
      type: Object
    }
  },
  computed: {
    listaMonitoramentoConsumos () {
      return this.listaConsumos
    },
    tabelaSemRegistros () {
      return this.listaConsumos.length === 0
    },
    flags () {
      return this.flagsDeControle
    }
  },

  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
    formatarCampo (valor, chave, linha) {
      if (util.valorEhNulo(valor)) return valor

      const descricao = linha.item.descricao.toLowerCase()
      const plano = linha.item.itens['plano']

      const eArmazenamento = descricao === 'armazenamento'
      const eProcessos = descricao === 'processos' && plano >= 1000000

      if (eArmazenamento) {
        if (valor > 0) {
          return `${valor}GB`
        } else if (valor <= 0 && chave !== 'utilizado' && chave !== 'saldo') {
          return '-'
        } else if (valor <= 0 && chave === 'saldo') {
          return `0GB`
        } else if (valor <= 0 && chave === 'utilizado') {
          return `0GB`
        }
      }

      if (eProcessos) {
        if (chave === 'saldo' || chave === 'plano') {
          return 'Ilimitado'
        }
      }

      if (valor === 0 && chave !== 'plano' && valor === 0 && chave !== 'adicional') {
        return '0'
      }

      return valor > 0 ? `${valor}` : '-'
    },
    obterIcone (icone) {
      return obterIcone(icone)
    },
    definirClasseLinha (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center trCorTextoPadrao'
      }
      return 'trCorTextoPadrao'
    }
  }
}
